import { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/** 路径与可访问该页所需的权限（满足其一即可） */
const PATH_REQUIRED_PERMISSIONS: Record<string, string[]> = {
  '/': ['dashboard:summary', 'dashboard:distribution', 'dashboard:recent_activities'],
  '/data': ['data_sources:list', 'data_sources:summary'],
  '/assets': ['asset_products:list', 'asset_products:detail'],
  '/analytics': ['analytics:indicators', 'analytics:reports_list', 'analytics:asset_distribution', 'analytics:trend_analysis', 'analytics:comparison_analysis', 'analytics:amount_dimension'],
  '/settings': ['settings:profile_get', 'settings:system_get', 'settings:notifications_get', 'settings:security_get'],
  '/settings/profile': ['settings:profile_get', 'settings:system_get', 'settings:notifications_get', 'settings:security_get'],
  '/settings/security': ['settings:profile_get', 'settings:system_get', 'settings:notifications_get', 'settings:security_get'],
  '/accounts': ['user_management:list'],
  '/roles': ['role_management:list'],
}

interface RequirePagePermissionProps {
  children: React.ReactNode
}

/**
 * 根据当前路由校验页面权限，仅当用户拥有该页面对应的任一按钮权限时渲染子组件，否则重定向到首页。
 * 与登录接口返回的 data.buttonPermissions 一致。
 */
export default function RequirePagePermission({ children }: RequirePagePermissionProps) {
  const { pathname } = useLocation()
  const { hasPermission } = useAuth()

  const allowed = useMemo(() => {
    const codes = PATH_REQUIRED_PERMISSIONS[pathname]
    if (!codes?.length) return true
    return codes.some((code) => hasPermission(code))
  }, [pathname, hasPermission])

  if (!allowed) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
